import produce from "immer";
import { createSelector } from "reselect";
import { Store } from "./rootReducer";
import { useDispatch, useSelector } from "react-redux";
import React from "react";

type State = {
  [projectID: number]: {
    filterString: string;
  };
};

const CHANGE_FILTER = "app/filters/CHANGE_FILTER";

type Action = {
  type: typeof CHANGE_FILTER;
  projectID: number;
  filterString: string;
};

const initialState: State = {};

export function reducer(state = initialState, action: Action): State {
  return produce(state, draft => {
    switch (action.type) {
      case CHANGE_FILTER:
        if (draft[action.projectID]) {
          draft[action.projectID].filterString = action.filterString;
        } else {
          draft[action.projectID] = { filterString: action.filterString };
        }
        break;
    }
  });
}

export const selectFilters = (state: Store) => state.filters;

export const selectFilter = (projectID: number) =>
  createSelector(selectFilters, filters => filters[projectID]);

export function useSubmitFilter(projectID: number) {
  const dispatch = useDispatch();

  const submit = React.useCallback(
    (filterString: string) =>
      dispatch({ type: CHANGE_FILTER, filterString, projectID }),
    [dispatch, projectID]
  );

  return submit;
}

export function useSelectFilter(projectID: number) {
  const selector = selectFilter(projectID);
  const filter = useSelector(selector);

  return filter;
}
